/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */

import * as uuid from 'uuid';
import { datadogRum } from '@datadog/browser-rum';
import { NotificationItem } from '../components/common/Notifications/NotificationItem';
import { PageAction, PageActionType } from '../actions/pageActions';

export const getInitialState = (): { notifications: any[] } => ({
  notifications: [],
});

export function pageReducer(state = getInitialState(), action: PageAction) {
  switch (action.type) {
    case PageActionType.ADD_NOTIFICATIONS:
      const payload: NotificationItem.PropsWithoutId[] = action.payload as NotificationItem.PropsWithoutId[];
      payload.forEach(notification => {
        datadogRum.addAction(`Show notification ${notification.content}`);
      });

      const notificationsToAdd: NotificationItem.Props[] = payload.map(
        (notification: NotificationItem.PropsWithoutId) => ({
          ...notification,
          id: uuid.v4(),
        }),
      );
      const filteredExistingNotifications = state.notifications.filter(
        notification => !notificationsToAdd.find(n => n.content === notification.content),
      );
      return {
        ...state,
        notifications: [...filteredExistingNotifications, ...notificationsToAdd],
      };

    case PageActionType.REMOVE_NOTIFICATION:
      const notificationIdToRemove: string = action.payload as string;
      return {
        ...state,
        notifications: state.notifications.filter(
          (notification: NotificationItem.Props) => notification.id !== notificationIdToRemove,
        ),
      };

    default:
      return state;
  }
}
